import { CheckCircleFilled } from '@ant-design/icons';
import {
  Popconfirm, Popover, Typography,
} from 'antd';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useConfirmRecruitmentRequest } from 'src/gql/mutations/recruitment';
import { RecruitmentBoarderRequest } from 'src/shared/types/api';
import { RecruitmentEventEnum } from 'src/shared/types/docs';

type ConfirmRecruitmentButtonProps = {
  record: RecruitmentBoarderRequest;
}

export const ConfirmRecruitmentButton = ({ record }: ConfirmRecruitmentButtonProps) => {
  const { t } = useTranslation();

  const [popConfirmVisible, setPopConfirmVisible] = useState(false);
  const [disabled, setDisabled] = useState(
    record.events.some(
      ({ event }) => event === RecruitmentEventEnum.REQUEST_CONFIRMED,
    ),
  );

  const [
    confirmRecruitmentRequest,
    loading,
  ] = useConfirmRecruitmentRequest({
    boarderRecruitmentId: record.boarderRecruitmentId,
    onSuccess: () => setDisabled(true),
    onComplete: () => setPopConfirmVisible(false),
  });

  return (
    <Popconfirm
      title={t('Confirm recruitment request')}
      okText={t('Yes')}
      visible={popConfirmVisible}
      onConfirm={confirmRecruitmentRequest}
      okButtonProps={{ loading }}
      onCancel={() => setPopConfirmVisible(false)}
      overlayStyle={{ width: 512 }}
    >
      <Popover content={t('Confirm recruitment payment')}>
        <Typography.Link disabled={disabled}>
          <CheckCircleFilled onClick={() => setPopConfirmVisible(true)} />
        </Typography.Link>
      </Popover>
    </Popconfirm>
  );
};
